import footerImage from "../../assets/images/footer-icon.svg";
import { COLORS } from "../../assets/utils/enums/colors";
import { LittleText } from "../typography";

const Footer: React.FC = () => {
  return (
    <footer
      className="w-100 d-flex align-items-center gap-1 justify-content-end"
    >
      <img src={footerImage} alt="footer-image" />
      <LittleText style={{ color: COLORS["bg-text-color"], lineHeight: "20px" }} > {new Date().getFullYear()}</LittleText>
    </footer >
  );
};

export default Footer;
